// axiosRetry.js
import { safeStringify } from '@ninjacart/nc-nk-core';
import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { KissanEventType } from './eventConstants';
import { crashlytics } from '@ninjacart/nc-nk-firebase';

const RETRY = 2;
const RETRY_DELAY = 1000;
export const handleRetry = async (error, config, API_FAILED_NAME, Client) => {
  if (!config || !RETRY) {
    return Promise.reject(error);
  }

  if (error?.code === 'ERR_NETWORK') {
    return Promise.reject(error);
  }

  config.__retryCount = config.__retryCount || 0;
  console.log('Retry b => ', config.__retryCount);

  if (config.__retryCount >= RETRY) {
    console.error(`${API_FAILED_NAME} error:`, error);
    crashlytics().log(`${API_FAILED_NAME}: ${error.config.url}`);
    crashlytics().recordError(error, `${API_FAILED_NAME}`);

    const additionalDetails = [
      addEventParam('errorMessage', error.toString()),
      addEventParam('apiError', safeStringify(error)),
      addEventParam('errorCode', error?.code),
      addEventParam('url', error.config.url),
    ];

    const apiErrorEvent: INinjaEvent = {
      name: KissanEventType.API_ERROR,
      screenDetails: { screen: 'api error' },
      eventParams: additionalDetails,
    };

    useQueuedEventStore.getState().enqueue(apiErrorEvent);
    return Promise.reject(error);
  }

  config.__retryCount += 1;
  await timeout(config.__retryCount * (RETRY_DELAY || 1000));
  return Client(config);
};

const timeout = (delay) => {
  return new Promise((res) => setTimeout(res, delay));
};
